module.exports = __webpack_public_path__ + "img/advance4.d6307fca.png";